import { render, staticRenderFns } from "./ShareWithMe.vue?vue&type=template&id=1a858da9&scoped=true&"
import script from "./ShareWithMe.vue?vue&type=script&lang=js&"
export * from "./ShareWithMe.vue?vue&type=script&lang=js&"
import style0 from "./ShareWithMe.vue?vue&type=style&index=0&id=1a858da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a858da9",
  null
  
)

export default component.exports